import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Custom Link component with scroll to top
  const ScrollLink = ({ to, children }) => (
    <a 
      href={to}
      onClick={(e) => {
        e.preventDefault();
        handleNavigation(to);
      }}
    >
      {children}
    </a>
  );

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.footerGrid}>
          {/* Solutions Section */}
          <div className={styles.footerSection}>
            <h3>Solutions</h3>
            <Link to="/solutions/bid-management">Bid Management</Link>
            <Link to="/solutions/estimation">Cost Estimation</Link>
            <Link to="/solutions/project-management">Project Management</Link>
            <Link to="/solutions/daily-updates">Daily Updates</Link>
            <Link to="/solutions/material-management">Material Management</Link>
            <Link to="/solutions/equipment">Equipment Management</Link>
            <Link to="/solutions/ai-agent">AI Assistant</Link>
          </div>

          {/* Resources Section */}
          <div className={styles.footerSection}>
            <h3>Resources</h3>
            <Link to="/resources/blog">Industry Blog</Link>
            <Link to="/resources/case-studies">Case Studies</Link>
            <Link to="/resources/templates">Document Templates</Link>
            <Link to="/resources/calculators">Construction Calculators</Link>
            <Link to="/resources/testimonials">Customer Stories</Link>
          </div>

          {/* Support Section */}
          <div className={styles.footerSection}>
            <h3>Support</h3>
            <Link to="/support/community">Community Forum</Link>
            <Link to="/support/knowledge-base">Knowledge Base</Link>
            <Link to="/support/tutorials">Video Tutorials</Link>
            <Link to="/support/contact">Contact Support</Link>
            <Link to="/request-demo">Request Demo</Link>
          </div>

          {/* Company Section */}
          <div className={styles.footerSection}>
            <h3>Company</h3>
            <Link to="/about">About Us</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/partners">Partner Program</Link>
            <Link to="/press">Press Room</Link>
            <Link to="/security">Security</Link>
            <Link to="/compliance">Compliance</Link>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <div className={styles.socialLinks}>
            <a href="https://linkedin.com/company/smarttech-proserve" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://twitter.com/smarttechpro" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://facebook.com/smarttechproserve" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://youtube.com/smarttechpro" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
          
          <div className={styles.footerLegal}>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/security">Security</Link>
            <Link to="/gdpr">GDPR</Link>
            <Link to="/accessibility">Accessibility</Link>
          </div>
          
          <div className={styles.footerContact}>
            <div className={styles.contactItem}>
              <i className="fas fa-phone"></i>
              <span>+1 (888) 123-4567</span>
            </div>
            <div className={styles.contactItem}>
              <i className="fas fa-envelope"></i>
              <span>support@smarttechproserve.com</span>
            </div>
            <div className={styles.contactItem}>
              <i className="fas fa-map-marker-alt"></i>
              <span>123 Construction Ave, Suite 100, New York, NY 10001</span>
            </div>
          </div>
          
          <p className={styles.footerCopyright}>
            © {new Date().getFullYear()} SmartTech ProServe. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 